import { useTranslation } from 'react-i18next';
import './SubscriptionErrorScreen.css';

/**
 * Écran bloquant affiché quand aucun service n'est disponible.
 *
 * Props :
 *   reason   'noCredits' | 'notActivated'
 *   onClose  () => void
 */
function SubscriptionErrorScreen({ reason, onClose }) {
  const { t } = useTranslation('results');
  const { t: tc } = useTranslation('common');

  const message =
    reason === 'notActivated'
      ? t('errors.servicesNotActivated')
      : t('errors.bothServicesUnavailable');

  return (
    <div className="subscription-error-screen">
      <div className="subscription-error-screen__icon">
        <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
          <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="2" />
          <path
            d="M24 14v12M24 32v2"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <p className="subscription-error-screen__message">{message}</p>

      <button className="btn btn-secondary" onClick={onClose}>
        {tc('buttons.close')}
      </button>
    </div>
  );
}

export default SubscriptionErrorScreen;
